import {configureStore} from '@reduxjs/toolkit';
import thunk from 'redux-thunk';

// Importe todos os seus reducers como named imports
import {appStatusReducer} from "./modules/app_status/reducer";
import areasReducer from "./modules/area/reducer";
import sidebarReducer from './modules/sidebar/reducer';
import loginReducer from './modules/login/reducer';
import currentAppData from './modules/app_data/reducer';
import layoutReducer from "./modules/settings/reducer";
import documentModelsReducer from './modules/model/reducer';
import {projectsReducer} from "./modules/projects/reducer";

const store = configureStore({
	reducer: {
		areas: areasReducer,
		app_status: appStatusReducer,
		app_data: currentAppData,
		user: loginReducer,
		sidebar: sidebarReducer,
		layout: layoutReducer,
		documentModels: documentModelsReducer,

		projects: projectsReducer
	},
	middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
	devTools: process.env.NODE_ENV !== 'production'
});

export default store;
